import { clsx, type ClassValue } from "clsx"
import { twMerge } from "tailwind-merge"

/** Combine class names + resolve Tailwind conflicts. */
export function cn(...inputs: ClassValue[]): string {
  return twMerge(clsx(inputs))
}

/** Shared focus ring token — every focusable primitive uses this so the ring
 *  stays identical across Input, Select, Textarea, Combobox, IconButton. */
export const focusRing =
  "focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-[color:var(--brand)]"
